import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-show-error',
  imports: [CommonModule],
  templateUrl: './show-error.component.html',
  styles: ``,
})
export class ShowErrorComponent {
  @Input() control!: AbstractControl | null;
  @Input() fieldName?: string;

  readonly errorMessages: Record<string, (params?: any) => string> = {
    required: () => `Ingrese ${this.fieldName || 'este campo obligatorio'}`,
    allWhitespace: () =>
      `${this.capitalizar()} no puede contener solo espacios`,
    noExtraSpaces: () =>
      `${this.capitalizar()} solo debe tener un espacio entre palabras`,
    whitespace: () => `${this.capitalizar()} no puede estar vacío`,
    minlength: (p) =>
      `${this.capitalizar()} debe tener al menos ${
        p?.requiredLength
      } caracteres`,
    maxlength: (p) =>
      `${this.capitalizar()} no debe exceder ${p?.requiredLength} caracteres`,
    min: (p) => `${this.capitalizar()} debe ser mayor o igual que ${p?.min}`,
    max: (p) => `${this.capitalizar()} debe ser menor o igual que ${p?.max}`,
    email: () => `Ingrese un ${this.fieldName || 'correo'} válido`,
    pattern: () => `${this.capitalizar()} tiene un formato inválido`,
    minLength: (params?: any) =>
      `El ${params?.fieldName || 'campo'} debe tener ${
        params?.requiredLength
      } caracteres.`,
    maxLength: (params?: any) =>
      `El ${params?.fieldName || 'campo'} debe tener máximo ${
        params?.requiredLength
      } caracteres.`,
    dateLessThanToday: () =>
      `${this.capitalizar()} debe ser igual o mayor que hoy`,
    dateGreaterThanToday: () =>
      `${this.capitalizar()} debe ser igual o menor que hoy`,
    integerOnly: () => `${this.capitalizar()} solo acepta números enteros`,
    invalidDate: () =>
      `${this.capitalizar()} no tiene un formato válido (DD/MM/YYYY)`,
    nonexistentDate: () =>
      `${this.capitalizar()} no corresponde a una fecha real`,
    yearOutOfRange: () =>
      `${this.capitalizar()} debe estar entre 1900 y el año actual`,
    underAge: () => `${this.capitalizar()} requiere ser mayor de edad`,
    dateRangeInvalid: () =>
      `La fecha de inicio no puede ser mayor que la fecha de fin`,
  };

  get errorKeys(): string[] {
    return this.control?.errors ? Object.keys(this.control.errors) : [];
  }

  getErrorMessage(key: string, params?: any): string {
    return (
      this.errorMessages[key]?.(params) ||
      `Error en ${this.fieldName || 'el campo'}`
    );
  }

  capitalizar(): string {
    return this.fieldName
      ? this.fieldName.charAt(0).toUpperCase() + this.fieldName.slice(1)
      : 'El campo';
  }
}
